import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ComunicacionRecibida, EmailService } from '../../../services/email.service';
import { VistaCorreoComponent } from '../../vista-correo/vista-correo.component';

/** Histórico de las comunicaciones que ha recibido el usuario conectado. */
@Component({
  selector: 'app-comunicaciones-recibidas-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule, MatDividerModule, MatProgressSpinnerModule, VistaCorreoComponent],
  templateUrl: './comunicaciones-recibidas-dialog.component.html',
  styleUrls: ['./comunicaciones-recibidas-dialog.component.scss'],
})
export class ComunicacionesRecibidasDialogComponent implements OnInit {
  lista: ComunicacionRecibida[] = [];
  abierta: ComunicacionRecibida | null = null;
  cargando = true;
  cargandoDetalle = false;
  error = '';

  constructor(private emailService: EmailService) {}

  ngOnInit(): void {
    this.emailService.getRecibidas().subscribe({
      next: lista => { this.lista = lista; this.cargando = false; },
      error: () => { this.error = 'No se han podido cargar las comunicaciones.'; this.cargando = false; },
    });
  }

  abrir(c: ComunicacionRecibida): void {
    this.abierta = c;
    this.cargandoDetalle = true;
    this.emailService.getRecibidaById(c._id).subscribe({
      next: detalle => { this.abierta = detalle; this.cargandoDetalle = false; },
      error: () => { this.abierta = { ...c, htmlBody: '' }; this.cargandoDetalle = false; },
    });
  }

  volver(): void {
    this.abierta = null;
  }
}
